import {
  CATALOG_FONT_SCALE_MAX,
  CATALOG_FONT_SCALE_MIN,
} from "@/features/catalog/stores/catalogStore";

const MOBILE_INTRINSIC_HEIGHT_AT_FOUR_COLUMNS = 145.25;
const MOBILE_INTRINSIC_HEIGHT_AT_EIGHT_COLUMNS = 97.125;

/**
 * カタログ外観設定をCSSカスタムプロパティへ落とすための純関数群。
 * 反映処理そのものは DesktopCatalogGridLayout が行う。
 */

/**
 * --catalog-font-scale に入れる倍率。CSSは calc(... * var(--catalog-font-scale, 1))
 * で受けるため、%ではなく倍率へ変換する。壊れた値・範囲外はここで丸めるので、
 * calc()へ0や負数が流れてカタログの文字が消えることはない。
 */
export function resolveCatalogFontScaleValue(percent: number): string {
  const clamped = Math.max(
    CATALOG_FONT_SCALE_MIN,
    Math.min(
      CATALOG_FONT_SCALE_MAX,
      Number.isFinite(percent) ? Math.floor(percent) : CATALOG_FONT_SCALE_MIN,
    ),
  );
  return String(clamped / 100);
}

/**
 * Use the measured mobile card heights at the common 4- and 8-column layouts.
 * Intermediate column counts interpolate between those measurements.
 */
export function resolveMobileCatalogIntrinsicHeight(columns: number): string {
  const measuredColumnRange = 8 - 4;
  const normalizedColumns = Math.max(
    4,
    Math.min(8, Number.isFinite(columns) ? Math.floor(columns) : 4),
  );
  const height =
    MOBILE_INTRINSIC_HEIGHT_AT_FOUR_COLUMNS +
    ((MOBILE_INTRINSIC_HEIGHT_AT_EIGHT_COLUMNS -
      MOBILE_INTRINSIC_HEIGHT_AT_FOUR_COLUMNS) /
      measuredColumnRange) *
      (normalizedColumns - 4);
  return `${height}px`;
}
